import CommonProductCard from '@/components/ProductCard/CommonProductCard';
import NewProductCard from '@/components/ProductCard/NewProductCard';
import { styled } from 'styled-components';
import { ProductContent } from '../../types/product';

interface FeaturedProductSectionProps {
  data: ProductContent[];
  isNew?: boolean;
  isSpecial?: boolean;
}

export default function FeaturedProductSection({
  isNew,
  data,
  isSpecial,
}: FeaturedProductSectionProps) {
  return (
    <Section>
      <ProductGrid isSpecial={isSpecial}>
        {data.map((product) =>
          isNew ? (
            <NewProductCard key={product.id} {...product} />
          ) : (
            <CommonProductCard key={product.id} {...product} isSpecial={isSpecial} />
          )
        )}
      </ProductGrid>
    </Section>
  );
}

const Section = styled.section`
  width: 100%;
  margin-bottom: 120px;
`;

const ProductGrid = styled.div<{ isSpecial?: boolean }>`
  display: grid;
  justify-items: center;
  gap: 16px;
  width: 100%;

  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); /* 기본 PC 크기 */

  @media (max-width: 1024px) {
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr); /* 태블릿에서는 2개 */
  }

  @media (max-width: 480px) {
    grid-template-columns: repeat(2, 1fr); /* 모바일에서도 2개 유지 */
    gap: 5px;
  }

  @media (max-width: 375px) {
    grid-template-columns: repeat(2, minmax(130px, 1fr)); /* 375px 이하에서는 1개 */
  }
`;
